export default "__VITE_ASSET__BCg$Mk4Z__"